/**
 * SearchBox Component
 * Encapsulated search input with icon
 */

import React from 'react';
import { Box, InputBase, InputBaseProps } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

export interface SearchBoxProps extends Omit<InputBaseProps, 'sx'> {
  containerSx?: object;
  inputSx?: object;
}

export const SearchBox: React.FC<SearchBoxProps> = ({
  containerSx,
  inputSx,
  ...props
}) => {
  const theme = useTheme();
  
  return (
    <Box
      sx={{
        position: 'relative',
        borderRadius: theme.shapes.borderRadius.md,
        backgroundColor: theme.customColors.searchBackground,
        border: `1px solid ${theme.customColors.searchBorder}`,
        '&:hover': {
          borderColor: theme.palette.primary.main,
        },
        '&:focus-within': {
          borderColor: theme.palette.primary.main,
        },
        ...containerSx,
      }}
    >
      <Box
        sx={{
          padding: theme.spacing(0, 1.5),
          height: '100%',
          position: 'absolute',
          pointerEvents: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <SearchIcon sx={{ color: theme.palette.text.secondary }} />
      </Box>
      <InputBase
        sx={{
          color: theme.palette.text.primary,
          width: '100%',
          padding: theme.spacing(1.5, 1.5, 1.5, 5),
          ...theme.typography.body2,
          ...inputSx,
        }}
        {...props}
      />
    </Box>
  );
};
